<mc-header-bar [headerModel]="headerModel" (saveEvent)="saveChanges()" (cancelEvent)="cancelChanges()"></mc-header-bar>

<div>
  <div class=" builder-content "
    [ngClass]="{ 'switchToHorizontal': previewModelHome.isVertical,'is-vertical-open': previewModelHome.isCollapsed  }">
    <div id="mainContainer" [ngClass]="{'switchVertical columns': previewModelHome.isVertical }">
    <div class="has-builder-header-content" [ngClass]="{ 'column is-main-section-vertical': previewModelHome.isVertical,
         'is-6' : isExpandedVertical(), 'is-11' : isCollapsedVertical() }" class="main-section" id="mainSection">
        <!-- <div class="main-section" id="mainSection"> -->

        <div class="header-panel">
          <div class=" has-header">
            <div class="nav-return-bar">
              <ul>
                <li class="has-link ">
                  <a (click)="navigateBack()">
                    <span class="icon">
                      <i class="fas fa-arrow-left"></i>
                    </span>
                    <span class="link-text">Back to Subject Landing</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="  form-page columns is-marginless">
          <div class="column  is-12 ">
            <div class="main-postprocessing">
              <h3 class="patient-postprocessing-title">Post Processing Event: {{eventName}}</h3>
              <table class="table is-fullwidth is-borderless is-striped postprocessing-table" role="grid ">
                <tbody>
                  @for (row of caseIntegrationStatusList; track row; let idx = $index) {
                    <tr>
                      <td>{{row.targetSystem}} </td>
                      <td>{{row.transactionResult}} </td>
                      <td class="min">
                        @if (isResendAllowed(row)) {
                          <button class="button is-small is-primary " (click)="postProcessingAction(row, 'resend', idx)" [disabled]="isResendDisabled(row)">
                            Resend Enrollment
                          </button>
                        }
                        @if (isUpdateAllowed(row)) {
                          <button class="button is-small is-primary " (click)="postProcessingAction(row, 'update', idx)" [disabled]="isUpdateDisabled(row)">
                            Update
                          </button>
                        }
                      </td>
                      <td>
                        <button class="button is-small is-primary " (click)="postProcessingAction(row, 'history', idx)">
                          History
                        </button>
                      </td>
                      @if (row?.ravePatientInfo?.siteMismatch) {
                        <td class="site-mis-match-msg">
                          {{row?.ravePatientInfo?.siteMismatchMsg}}
                        </td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
<div class="preview-section" id="previewSection" [ngClass]="{ 'togglePerviewOverlay' : isExpandedHorizontal(),                
'is-6 preview-vertical-expanded' : isExpandedVertical(),
 'is-1' : isCollapsedVertical(),
'column ': previewModelHome.isVertical , 'isCollapsedHorizontal' : isCollapsedHorizontal()}">
        <mc-preview [formTitle]="" [formCaption]="previewTitle" [previewModel]="previewModelHome" #previewSection>
          <div preview-data>
            @if (historyTarget) {
              <div class="columns">
                <div class="column">
                  @if (!postProcessingHistoryRecords || postProcessingHistoryRecords.length === 0) {
                    <section class="section">
                      <div class="container">
                        <div class="subtitle has-text-centered">
                          <h2 class="has-text-weight-bold">
                            No History Found
                          </h2>
                        </div>
                      </div>
                    </section>
                  }
                  @if (isRavePreview()) {
                    <mc-post-processing-history-preview
                    [postProcessingHistoryRecords]="postProcessingHistoryRecords"></mc-post-processing-history-preview>
                  }
                  @if (isPmbV2OrBioMsPreview()) {
                    <mc-post-processing-history-preview-pb
                    [postProcessingHistoryRecords]="postProcessingHistoryRecords"></mc-post-processing-history-preview-pb>
                  }
                  @if (isPMBorMcKessonPreview()) {
                    <mc-post-processing-history-preview-pm
                    [postProcessingHistoryRecords]="postProcessingHistoryRecords"></mc-post-processing-history-preview-pm>
                  }
                </div>
              </div>
            }
          </div>
        </mc-preview>
      </div>
    </div>


  </div></div>